module.exports = __webpack_public_path__ + "media/images/favicon/mstile-150x150-bf38c988bc594eb44d8ec3218829bb65.png";